export const getCompanyDisplayText = (company?: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => {
  return `${company?.milesBerCode}/${company?.brand?.name}`;
};

// Returns the company label, inserting a line break if it exceeds the wrap boundary
export const formatCompanyLabelForDisplay = (
  company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData,
  companyLabelWrapBoundary: number
) => {
  const companyDisplayText = getCompanyDisplayText(company) ?? '';
  return companyDisplayText?.length > companyLabelWrapBoundary
    ? companyDisplayText.replace('/', '/\n')
    : companyDisplayText;
};
